module.exports = __webpack_public_path__ + "images/down-arrow-cb75b46a.png";